import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import clsx from 'clsx';
import { ToggleButtonGroup as MuiToggleButtonGroup, } from '@material-ui/lab';
import { makeStyles } from '@material-ui/styles';
import { Liquidity } from '../../design';
// this is an option for styling buttons underneath a themed button group
// material does it this way: https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/ButtonGroup/ButtonGroup.js
const useGroupStyles = makeStyles((theme) => ({
    root: {
        '& .MuiToggleButton-root': {
            fontSize: '0.875rem',
            fontWeight: 600,
            padding: theme.spacing(0.5, 3.5),
            textTransform: 'none',
        },
        '& .MuiToggleButton-root.MuiToggleButton-sizeLarge': {
            fontSize: '1rem',
            padding: theme.spacing(1, 3),
        },
    },
    inherit: {},
    default: {
        '& .MuiToggleButton-root': {
            borderColor: 'rgba(0, 0, 0, 0.25)',
            color: Liquidity.colors.text.standard,
        },
        '& .MuiToggleButton-root.Mui-selected': {
            backgroundColor: Liquidity.colors.supporting.grey25,
        },
    },
    primary: {
        '& .MuiToggleButton-root': {
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
        },
        '& .MuiToggleButton-root.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.getContrastText(theme.palette.primary.main),
        },
    },
    secondary: {
        '& .MuiToggleButton-root': {
            borderColor: theme.palette.secondary.main,
            color: theme.palette.secondary.main,
        },
        '& .MuiToggleButton-root.Mui-selected': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.getContrastText(theme.palette.secondary.main),
        },
    },
}));
export const ToggleButtonGroup = React.forwardRef((_a, ref) => {
    var { children, color, className } = _a, props = __rest(_a, ["children", "color", "className"]);
    const classes = useGroupStyles({ color });
    return (_jsx(MuiToggleButtonGroup, Object.assign({ ref: ref, className: clsx(classes.root, color && classes[color]) }, props, { children: children }), void 0));
});
export { ToggleButton } from '@material-ui/lab';
//# sourceMappingURL=ToggleButton.js.map